module.exports = __webpack_public_path__ + "inputs/img/map.d9e1c729.png";